import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Map, NavigationControl } from 'maplibre-gl';
import { Observable } from 'rxjs';
import { MapManagerService } from 'src/app/instant-analysis/services/map-manager/map-manager.service';
import { ServiceService } from 'src/app/instant-analysis/services/service.service';
import { environment } from 'src/environments/environment';
import { HeuristicService } from '../services/heuristic/heuristic.service';
import { MapboxDrawCustom } from '../../instant-analysis/map/mapbox-aux/mapbox-draw-const';
import { MapComponent } from 'src/app/instant-analysis/map/map.component';
import { routerToMainService } from '../../instant-analysis/services/routerToMainService';
import { DashboardToMapService } from 'src/app/dashboard/services/dashboard-to-map-service.service';
import { SocketIoServerService } from '../../instant-analysis/services/socket-io-server/socket-io-server.service';
import { VoronoiService } from 'src/app/instant-analysis/services/voronoi/voronoi.service';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-routesmap',
  templateUrl: './routesmap.component.html',
  styleUrls: ['./routesmap.component.css']
})
export class RoutesmapComponent extends MapComponent implements OnInit {
  
  highways$: Observable<GeoJSON.FeatureCollection>;
  highwaysData: GeoJSON.FeatureCollection;
  
  map: Map;
  mapContainerId = 'routemap';
  style = 'mapbox://styles/mapbox/light-v10';
  lat = -22.9060074;
  lng = -43.0615941;
  
  showSidebar = false;
  menuIndex: number = null;
  
  // Variáveis de heurística
  guards: number = 8;
  interzone: number = 2;
  intrazone: number = 3;
  maxRouteInterzone: number = 3500.00;
  maxRouteIntrazone: number = 2100.00;
  
  // Rotas que retornam da heurística
  routesData: any;
  
  map_draw = MapboxDrawCustom.custom_style;

  constructor(
    service: ServiceService,
    mapManager: MapManagerService,
    snackBar: MatSnackBar,
    routerMessager: routerToMainService,
    dialog: MatDialog,
    routerReciever: DashboardToMapService,
    socketIo: SocketIoServerService,
    heuristicService: HeuristicService,
    voronoiService: VoronoiService,
    overlay: Overlay,
  ) {
    super(service, mapManager, snackBar, routerMessager, dialog, routerReciever, socketIo, heuristicService, voronoiService, overlay, null, null, null, null, null);
  }

  ngOnInit(): void {
    this.map = new Map({
      container: this.mapContainerId,
      style: this.style,
      zoom: 11.4,
      center: [this.lng, this.lat],
      logoPosition: "top-right",
      preserveDrawingBuffer: true,
    });

    this.map.addControl(new NavigationControl({showCompass: false}),"bottom-right");   //botões que controlam o zoom

    this.map.on('style.load', () => {

      this.map.getStyle().layers?.forEach((layer : any) => {
        if (layer.type === 'symbol') {
            this.map.removeLayer(layer.id);
        }
      });

      this.highways$ = this.service.getAll();
      this.highways$.subscribe((val)=>{
        this.highwaysData = val;
        this.mapManager.setMapSource(this.map, 'highways-data-source', this.highwaysData);
        this.mapManager.setMapLineLayer(this.map, 'highways-data-source', 'highways-line', '#808080', 1, 1);
      });
    });
    
    // this.map.addControl(this.map_draw,"bottom-right");
  }
  
  toggleSidebar() {
    this.showSidebar = ! this.showSidebar;
  }
  
  setMenuIndex(index: number) {
    this.menuIndex = index;
  }
  
  runHeuristic() {
    this.heuristicService.getHeuristicResult(
      this.guards,
      this.interzone,
      this.intrazone,
      this.maxRouteInterzone,
      this.maxRouteIntrazone,
    ).subscribe((result)=>{
      this.routesData = result;
      this.mapManager.setMapSource(this.map, 'routes-data-source', this.routesData);
      this.mapManager.setMapLineLayer(this.map, 'routes-data-source', 'routes-line', '#870d17', 1, 2);
      
      // atualiza a camada highway
      // this.map.setLayoutProperty('highways-line', 'visibility', 'none');
    });
  }
}
